var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "preview" }, [
    _c(
      "div",
      { staticClass: "scaler" },
      [
        _c("button", {
          staticClass: "scaler__inc",
          domProps: { innerHTML: _vm._s("&plus;") },
          on: {
            mousedown: function ($event) {
              _vm.isMousePressing = true
              _vm.mutateScale(_vm.scaleStep)
            },
            touchstart: function ($event) {
              _vm.isMousePressing = true
              _vm.mutateScale(_vm.scaleStep)
            },
            mouseleave: function ($event) {
              _vm.isMousePressing = false
            },
            touchend: function ($event) {
              _vm.isMousePressing = false
            },
            mouseup: function ($event) {
              _vm.isMousePressing = false
            },
          },
        }),
        _vm._v(" "),
        _c("i-slider", {
          attrs: {
            direction: "vertical",
            min: _vm.minScale,
            max: _vm.maxScale,
            step: _vm.scaleStep,
          },
          model: {
            value: _vm.scale,
            callback: function ($$v) {
              _vm.scale = $$v
            },
            expression: "scale",
          },
        }),
        _vm._v(" "),
        _c("button", {
          staticClass: "scaler__dec",
          domProps: { innerHTML: _vm._s("&minus;") },
          on: {
            mousedown: function ($event) {
              _vm.isMousePressing = true
              _vm.mutateScale(-_vm.scaleStep)
            },
            touchstart: function ($event) {
              _vm.isMousePressing = true
              _vm.mutateScale(-_vm.scaleStep)
            },
            mouseleave: function ($event) {
              _vm.isMousePressing = false
            },
            touchend: function ($event) {
              _vm.isMousePressing = false
            },
            mouseup: function ($event) {
              _vm.isMousePressing = false
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("i-scale-image", {
          staticClass: "viewer",
          attrs: { scale: _vm.scale, src: _vm.tags[_vm.index].photo },
          on: {
            "update:scale": function ($event) {
              _vm.scale = $event
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tags.length > 1,
                expression: "tags.length > 1",
              },
            ],
            staticClass: "arrow left",
            on: { click: _vm.nextTag },
          },
          [_c("i", { staticClass: "isif isif-arrow-left" })]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tags.length > 1,
                expression: "tags.length > 1 ",
              },
            ],
            staticClass: "arrow right",
            on: { click: _vm.previousTag },
          },
          [_c("i", { staticClass: "isif isif-arrow-right" })]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }